import { useEffect, useState } from "react"
import AxiosHeader from "../utils/AxiosHeader"
import axios from "axios"
import Alert from "../components/common/Alert"
import { Link } from "react-router-dom"

const Administration = () => {
	const [alert, setAlert] = useState({})
	const [access, setAccess] = useState(false)
	const [registries, setregistries] = useState({})
	const [tanques, setTanques] = useState([])
	const [tanque, setTanque] = useState('')
	const [estado, setEstado] = useState('')
	const [fechaInicio, setFechaInicio] = useState('')
	const [fechaFin, setFechaFin] = useState('')
	const [effect, setEffect] = useState(0)

	const token = sessionStorage.getItem('token')
	const config = AxiosHeader(token)

	useEffect(() => {
		const getAllRegistries = async () => {
			try {
				const {data} = await axios.get(
					`${process.env.REACT_APP_URL_SERVER}/registry/findall-admin`,
					config
				)
				setAccess(true)
				setregistries(data)
			} catch (error) {
				setAlert({
					msg: error.response.data.msg,
					error: true
				})
			}
		}
		getAllRegistries()

		const consultarTanques = async () => {
			const {data} = await axios.get(
				`${process.env.REACT_APP_URL_SERVER}/user-tank/findall`,
				config
			)
			setTanques(data)
		}
		consultarTanques()

		setEffect(0)
	}, [effect])

	const consultarFiltro = async (e) => {
		try {
			e.preventDefault()
			setAlert({})
			const {data} = await axios.post(
				`${process.env.REACT_APP_URL_SERVER}/registry/consultar-filtro`,
				{
					tanque,
					estado,
					fechaInicio,
					fechaFin
				},
				config
			)
			setregistries(data)
		} catch (error) {
			setAlert({
				msg: error.response.data.msg,
				error: true
			})
		}
	}

	const cambiarEstado = async (e) => {
		try {
			e.preventDefault()
			setAlert({})
			const {data} = await axios.put(
				`${process.env.REACT_APP_URL_SERVER}/registry/cambio-estado`,
				{
					registries,
					estado
				},
				config
			)
			setAlert({
				msg: data.msg,
				error: false
			})
			setTimeout(() => {
                setAlert({})
            }, 5000);
			setEffect(1)
		} catch (error) {
			setAlert({
				msg: error.response.data.msg,
				error: true
			})
		}
	}

	return (
		<div className="dashboard col-9 col-sm-9 col-md-9 col-xl-10">
				<h1 className="h1-dashboard">Administración</h1>
				{alert.msg && <Alert alert={alert}></Alert>}
				<div className="container mt-3 mb-3">
					<div className="row">
						<div className="col-12 col-sm-3 text-center">
							<label htmlFor="tanque" className="form-label">Tanque:</label>
							<select
								id="tanque"
								className="form-select"
								onChange={e => setTanque(e.target.value)}
							>
								<option value=''>Tanque</option>
								{
									tanques.map((tanque, index) => (
										<option key={index} value={tanque.oid}>{tanque.name}</option>
									))
								}
							</select>
						</div>
						<div className="col-12 col-sm-3 text-center">
							<label htmlFor="estado" className="form-label">Estado:</label>
							<select
								id="estado"
								className="form-select"
								onChange={e => setEstado(e.target.value)}
							>
								<option value=''>Estado</option>
								<option value='0'>Registrado</option>
								<option value='1'>Registrado con calidad interna</option>
								<option value='2'>Descartado calidad</option>
								<option value='3'>Cerrado agregar</option>
								<option value='4'>Cerrado calidad interna</option>
								<option value='5'>Finalizado</option>
							</select>
						</div>
						<div className="col-12 col-sm-3 text-center">
							<label htmlFor="fecha-inicio" className="form-label">Fecha inicio:</label>
							<input
								type="date"
								id="fecha-inicio"
								className="form-control"
								onChange={e => setFechaInicio(e.target.value)}
							></input>
						</div>
						<div className="col-12 col-sm-3 text-center">
							<label htmlFor="fecha-fin" className="form-label">Fecha fin:</label>
							<input
								type="date"
								id="fecha-fin"
								className="form-control"
								onChange={e => setFechaFin(e.target.value)}
							></input>
						</div>
					</div>
					<div className="row">
						<div className="col-12 col-sm-4 text-start">
							<form onSubmit={consultarFiltro}>
								<button className="btn btn-primary boton-cambio-estado">Consultar</button>
							</form>
						</div>
						<div className="col-12 col-sm-4 text-start">
							<form onSubmit={cambiarEstado}>
								<button className="btn btn-success boton-cambio-estado">Cambiar estado</button>
							</form>
						</div>
						<div className="col-12 col-sm-4 text-start">
							<Link to={`/dashboard-admin/administration-finished`} className='bt-link btn btn-secondary boton-cambio-estado'>Registros finalizados</Link>
						</div>
					</div>
				</div>
				{
					access
					?
						registries.length > 0
						?
						<table className="table table-striped table-hover">
							<thead>
								<tr>
									<th scope="col">#</th>
									<th scope="col">Productor</th>
									<th scope="col">Tanque</th>
									<th scope="col">Fecha</th>
									<th scope="col">Hora</th>
									<th scope="col">Cantidad</th>
									<th scope="col">Tiene calidad interna</th>
									<th scope="col">Estado</th>
									<th scope="col">Ajuste</th>
									<th scope="col">Cambiar estado</th>
								</tr>
							</thead>
							<tbody>
								{
									registries.map((registry, index) => (
										<tr key={index}>
											<th scope="row">{index + 1}</th>
											<td>{registry.producer}</td>
											<td>{registry.usertank}</td>
											<td>{registry.date}</td>
											<td>{registry.hour === 0 ? 'AM' : 'PM'}</td>
											<td>{registry.amount}</td>
											{registry.has_internal_quality === 0 && <td>No</td>}
											{registry.has_internal_quality === 1 && <td>Si</td>}
											{registry.has_internal_quality === 2 && <td>Descartado</td>}
											{registry.registry_status === 0 && <td>Registrado</td>}
											{registry.registry_status === 1 && <td>Registrado</td>}
											{registry.registry_status === 2 && <td>Registrado</td>}
											{registry.registry_status === 3 && <td>Cerrado agregar</td>}
											{registry.registry_status === 4 && <td>Cerrado calidad interna</td>}
											{registry.registry_status === 5 && <td>Finalizado</td>}
											<td><Link to={`/dashboard-admin/adjustment/${registry.oid}`} className='btn btn-primary'></Link></td>
											<td><Link to={`/dashboard-admin/change-status/${registry.oid}`}  className='btn btn-success'></Link></td>
										</tr>
									))
								}
							</tbody>
						</table>
						:
						<h4>¡No hay registros para mostrar!</h4>
					:
					''
				}
			{/* </form> */}
		</div>
		)
	}

export default Administration